import React from 'react';
import { createIcon } from './create-icon';
import './icon-open-in-brandfolder.scss';

export const IconOpenInBrandfolder = createIcon(<div className="icon-open-in-brandfolder" />);
